(() => {
  const HEIGHT_MS = 350;
  const OPACITY_MS = 250;
  const OPACITY_DELAY_MS = 120;
  const EASE = 'cubic-bezier(.25,.46,.45,.94)';

  function rAF(cb){ return requestAnimationFrame(cb); }
  function forceReflow(el){ void el.offsetHeight; }

  function openPanel(details, panel){
    if (!details.open) details.open = true;
    
    panel.classList.add('is-transitioning');
    panel.style.overflow = 'hidden';
    panel.style.visibility = 'visible';
    panel.style.pointerEvents = 'auto';
    panel.style.opacity = '0';
    panel.style.height = '0px';
    
    const inner = panel.querySelector('.collapsible-content__inner');
    
    if (inner) {
      inner.style.transition = 'none';  
      inner.style.transform = 'translateY(0)';  
    }
    
    forceReflow(panel);
    
    const h = panel.scrollHeight;
    
    if (inner) {
      inner.style.transform = 'translateY(40px)';
      forceReflow(inner);  
    }
    
    panel.classList.add('is-open');
    panel.classList.remove('is-closing');

    rAF(() => {
      if (inner) {
        inner.style.transition = `transform ${HEIGHT_MS}ms ${EASE}`;
        inner.style.transform = 'translateY(0)';
      }
      
      panel.style.transition = 
        `height ${HEIGHT_MS}ms ${EASE}, opacity ${OPACITY_MS}ms ${EASE}`;
      panel.style.opacity = '1';
      panel.style.height = h + 'px'; 

      const done = (e) => {
        if (e.propertyName !== 'height') return;
        panel.removeEventListener('transitionend', done);
        panel.classList.remove('is-transitioning');
        panel.style.transition = '';
        panel.style.height = 'auto';
        
        if (inner) {
          inner.style.transition = '';
          inner.style.transform = '';
        }
      };
      panel.addEventListener('transitionend', done);
    });
  }

  function closePanel(details, panel){
    panel.classList.add('is-transitioning', 'is-closing');
    panel.classList.remove('is-open');

    const h = panel.scrollHeight;
    const inner = panel.querySelector('.collapsible-content__inner');
    
    panel.style.overflow = 'hidden';
    panel.style.visibility = 'visible';
    panel.style.pointerEvents = 'none';
    panel.style.transition =
      `height ${HEIGHT_MS}ms ${EASE}, opacity ${OPACITY_MS}ms ${EASE}`;
    panel.style.height = h + 'px';
    panel.style.opacity = '1';
    
    if (inner) {
      inner.style.transition = `transform ${HEIGHT_MS}ms ${EASE}`;
      inner.style.transform = 'translateY(0)';  
    }
    
    forceReflow(panel);

    rAF(() => {
      setTimeout(() => { panel.style.opacity = '0'; }, OPACITY_DELAY_MS);
      panel.style.height = '0px';
      
      if (inner) {
        inner.style.transform = 'translateY(40px)';
      }
    });

    const done = (e) => {
      if (e.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', done);
      panel.classList.remove('is-transitioning', 'is-closing');
      panel.style.transition = '';
      panel.style.height = '0px';
      panel.style.visibility = 'hidden';
      
      if (inner) {
        inner.style.transition = '';
        inner.style.transform = '';
      }
      
      details.open = false;
    };
    panel.addEventListener('transitionend', done);
  }

  function bindOne(details){
    const summary = details.querySelector(':scope > summary');
    const panel = details.querySelector(':scope > .collapsible-content, :scope > .collapsible-content--all');
    if (!summary || !panel || details.dataset.mAccordionBound === '1') return;
    details.dataset.mAccordionBound = '1';

    if (details.open) {
      panel.classList.add('is-open');
      panel.style.height = 'auto';
      panel.style.opacity = '1';
      panel.style.visibility = 'visible';
      panel.style.pointerEvents = 'auto';
    } else {
      panel.style.height = '0px';
      panel.style.opacity = '0';
      panel.style.visibility = 'hidden';
      panel.style.pointerEvents = 'none';
    }

    summary.addEventListener('click', (evt) => {
      evt.preventDefault();
      evt.stopPropagation();
      if (panel.classList.contains('is-transitioning')) return;
      if (details.open) closePanel(details, panel);
      else openPanel(details, panel);
    }, { passive: false });
  }

  function init(root = document){
    root.querySelectorAll('.menu-drawer details').forEach(bindOne);
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();